import { put, takeEvery, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "common/components/apiConfig";
import { handleNotificationAlertCatch,handleNotificationAlertTrySelect,handleNotificationAlertTryUpdate } from "common/method/handleNotificationAlert";



 export const actionTypes={
    selectOptionUaIsin:"[selectOptionUaIsin] Action",
    selectOptionUaIsinLoading:"[selectOptionUaIsinLoading] Action",
    selectOptionUaIsinAsync:"[selectOptionUaIsinAsync] Action",
}


const initialState = {
    data:[],
    datapage:[],
    loading:false,
    total:0
}

 export const select_option_ua_isin_reducer = (state=initialState,{type,payload})=>{

    switch (type) {
        case actionTypes.selectOptionUaIsin:
            return{
                ...state,
                data: payload?.data?.results ? payload?.data?.results :[],
                // total:payload?.data?.total ? payload?.data?.total :0
            }
        case actionTypes.selectOptionUaIsinLoading:
            return{
                ...state,
                loading:payload
            }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectOptionUaIsinLoading, payload: true });
    let config = {
        url: "select_request"
    };
    
    let data = {
        table: "option",
        method_type: "select_option_ua_isin",
        data: payload?.data ? payload.data : {},
    };
    
    try {
      let res = yield AxiosCustom(config, data);

      yield put({type:actionTypes.selectOptionUaIsin,payload:res.data.response})
    } catch {
      handleNotificationAlertCatch();
    }finally{
        yield put({ type: actionTypes.selectOptionUaIsinLoading, payload: false });

    }
  }


export function* selectOptionUaIsin() {
    yield takeEvery(actionTypes.selectOptionUaIsinAsync, handleWorker);
  }